import { cn } from "@/lib/utils";

/** Monochrome project glyph: a dot-grid tile with the project's initial. */
export function ProjectIcon({ name, className }: { name: string; className?: string }) {
	return (
		<span
			aria-hidden
			className={cn(
				"bg-dot-grid inline-flex size-5 shrink-0 items-center justify-center rounded-[5px] border bg-card font-mono text-[10px] font-semibold uppercase [--grid-size:4px]",
				className,
			)}
		>
			<span className="rounded-[2px] bg-card px-0.5 leading-none">{name.trim()[0] ?? "·"}</span>
		</span>
	);
}
